'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _nowAsEpoch = require('../date/nowAsEpoch');

var _nowAsEpoch2 = _interopRequireDefault(_nowAsEpoch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (contract) {
    var nowEpoch = (0, _nowAsEpoch2.default)();
    if (contract.tick_count) {
        var _start = +contract.date_start - 5;
        var exitTime = +contract.exit_tick_time + 5;
        var _end = exitTime || nowEpoch;
        return { start: _start, end: _end };
    }

    var bufferSize = 0.05; // 5 % buffer
    var contractStart = +contract.date_start;
    var contractEnd = +contract.exit_tick_time || +contract.date_expiry;

    if (contractEnd <= contractStart) {
        var e = new RangeError('Contract ends time is earlier than start time');
        e.name = 'ContractEndsBeforeStart';
        throw e;
    }

    var buffer = (contractEnd - contractStart) * bufferSize;
    var bufferedExitTime = contractEnd + buffer;

    var start = buffer ? contractStart - buffer : contractStart;
    var end = contractEnd ? bufferedExitTime : nowEpoch;

    return {
        end: Math.round(end),
        start: Math.round(start)
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/trade/computeStartEndForContract.js
// module id = 123
// module chunks = 0